module.exports = __webpack_public_path__ + "static/main_text-c62fa95b5e6400836d8418ca354b6b96.png";